module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"codeSent":"Abbiamo inviato un codice a 6 cifre al numero di telefono","submitCode":"Immetti il codice","snackError.VerifyMobilePhone":"Impossibile verificare il numero di telefono","snackError.InvalidCode":"Codice non valido","VerificationCode":"Codice di verifica","smsVerificationComplete":"Numero di telefono verificato!"}}')
  delete Component.options._Ctor
}
